import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { ApplicationQueryKeys } from "./keys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { CreateApplicationFormFields } from "../../models/Application/CreateApplication";
import { UpdateApplicationFormFields } from "../../models/Application/UpdateApplication";

export default function useApplicationMutations() {
  const queryClient = useQueryClient();
  const { saveHandlers } = useDefaultCRUDHandlers("Application");
  const { post, put } = useApiHelper();

  const create = useMutation({
    mutationFn: (application: CreateApplicationFormFields) =>
      post(`/application`, application),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ApplicationQueryKeys.all() });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const update = useMutation({
    mutationFn: (updateApplication: UpdateApplicationFormFields) =>
      put(`/application/${updateApplication.id}`, updateApplication),
    onSuccess: (_, updateInput) => {
      queryClient.invalidateQueries({ queryKey: ApplicationQueryKeys.all() });
      queryClient.invalidateQueries({
        queryKey: ApplicationQueryKeys.single(updateInput.id),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  // const remove = useMutation({
  //   mutationFn: (exampleId: string) => del(`/examples/${exampleId}`),
  //   onSuccess: (_, exampleId) => {
  //     queryClient.setQueryData(["examples"], (currentExamples: any) =>
  //       currentExamples?.filter((example: any) => example.id !== exampleId)
  //     );
  //   },
  // });

  return {
    create,
    update,
    // remove,
  };
}
